import toast from "react-hot-toast";
import { baseUrl } from "./baseUrl";

export async function deleteCampaign(id: string): Promise<void> {
  const token = sessionStorage.getItem("admin_token");
  try {
    const res = await fetch(
      `${baseUrl}/admin/campaigns/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      const err = await res.json().catch(() => null);
      if (
        err?.message?.toLowerCase() === "invalid token" ||
        err?.message?.toLowerCase() === "jwt malformed" ||
        err?.message?.toLowerCase() === "jwt expired"
      ) {
        sessionStorage.removeItem("admin_token");
        toast.error("Session expired, please log in again.");
        window.location.href = "/auth/sign-in";
        return Promise.reject(new Error("Unauthorized"));
      }
      throw new Error(err?.message ?? `HTTP ${res.status}`);
    }
    toast.success("Campaign deleted");
  } catch (error) {
    console.error("Error deleting campaign:", (error as Error).message);
    toast.error(`Delete failed: ${(error as Error).message}`);
    throw error;
  }
}
